import React from 'react'
import Img from 'gatsby-image'
import styled, { css } from 'styled-components'

import ScrollAnimation from 'react-animate-on-scroll'
import 'animate.css/animate.min.css'

const Styles = css`
    flex-grow: 1;

    width: 100%;
    margin: 0 auto;
`

const IllustrationWrapper = styled.div`
    ${Styles}

    max-width: ${props => props.theme.mobileVW(250)};
    padding-bottom: calc(${props => props.theme.space.paddingMobile} * 2);

    @media screen and (min-width: ${props => props.theme.breakpoints.desktop}) {
        max-width: ${props => props.theme.desktopVW(450)};
        
        padding-bottom: 0;
    }
`

const ImageWrapper = styled.div`
    ${Styles}

    overflow: hidden;
`

const StyledVideo = styled.video`
    position: relative;

    width: 100%;
`

const ContentVideo = ({
    data: {
        mp4, 
        ogg
    },
    delay
}) => {

    return (
        <ImageWrapper className='content-image image'>
            <ScrollAnimation animateIn='fadeInUp' delay={delay} duration={1.5}>
                <StyledVideo autoPlay muted loop>
                    {mp4.file && mp4.file.url && <source src={mp4.file.url} type='video/mp4' />}
                    {ogg.file && ogg.file.url && <source src={ogg.file.url} type='video/ogg' />}
                </StyledVideo>
            </ScrollAnimation>
        </ImageWrapper>
    )
}

export default ContentVideo